import { UserAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import Logo from '../images/logo.png';
import Cart from '../images/cart.png';
import Google from '../images/google.png';

export default function CheckOut({ cart, clearCart }) {

    const { user } = UserAuth();

    const { googleSignIn } = UserAuth();

    const handleGoogleSignIn = async () => {
        try {
            await googleSignIn();
        }
        catch (e) {
            console.log(e);
        }
    }
    window.onpopstate = () => {
        clearCart();
    }

    return (<div className='checkout-page'>
        <nav>
            <Link className='nav-link' to='/' onClick={() => clearCart()}>
                <img className='logo-img' src={Logo} alt='logo'/>
            </Link>
            <Link className='nav-link' to='/cart' onClick={() => clearCart()}>
                <img className='cart-img' src={Cart} alt='cart' />
            </Link>
        </nav>
        {(user) ? (<>
                <section className='purchased-container'>
                    <h2>Thank you for shopping with us</h2>
                    <div className='purchased-list'>
                        {(cart.length) ? cart.map(item =>
                            <Link className='purchased' to={`/products/${item.id}`} key={item.id} onClick={() => clearCart()}>
                                <img src={item.image} alt={item.title} />
                                <p className='book-title'>{item.title}</p>
                            </Link>
                        ): null}
                    </div>
                    <p>A confirmation email has been sent to {user.email}</p>
                    <p>Shipping details will be provided in the email</p>
                    <Link className='checkout-home-link' to='/' onClick={() => clearCart()}>Back To Main Page</Link>
                    
                </section>
                <Footer />
        </>) : (
            <div className='login-box'>
                <h2>Please Sign In</h2>
                <button className='google-btn' onClick={ handleGoogleSignIn }>
                    <img src={Google} alt='Google' />
                    <span>Log In with Google</span>
                </button>
            </div>
        )}
    </div>)

}
